import type { BlockInfo } from 'types/block-info';
import React from 'react';
import { Wrap } from '@leafwell/components';
import HeadingBody from './heading-body';
import WysiwygContent from './wysiwyg-content';

const Info: React.FC<BlockInfo> = ({
  sectionId,
  label,
  columns,
  title,
  content,
  subtitle,
}) => {
  const hasTitle = title?.length > 0;
  const hasSubTitle = subtitle?.length > 0;

  const halfColumns = columns === '2';
  const defaultSize = `md:col-span-${Math.floor(12 / parseInt(columns))}`;
  const columnClasses = {
    title: halfColumns ? 'md:col-span-5' : defaultSize,
    subtitle: defaultSize,
    content: halfColumns ? 'md:col-span-7' : defaultSize,
  };

  return (
    <Wrap
      id={sectionId}
      className={['gap-10 xl:gap-16 md:grid-cols-12'].join(' ')}
    >
      {label?.length > 0 && (
        <HeadingBody
          className="col-span-full text-center"
          level="2"
          title={label}
        />
      )}
      {hasTitle && (
        <HeadingBody
          className={['font-semibold', columnClasses.title].join(' ')}
          level="2"
          title={title}
          tagName="h2"
        />
      )}
      {hasSubTitle && (
        <WysiwygContent
          content={subtitle}
          className={[columnClasses.subtitle, '!text-lg xl:!text-xl'].join(' ')}
        />
      )}
      <WysiwygContent
        content={content}
        className={[columnClasses.content].join(' ')}
      />
    </Wrap>
  );
};

export default Info;
